import * as React from 'react';
import { StyledTree, StyledTreeItem, StyledTreeItemParent, OpenIcon, CloseIcon } from './Tree.style';
import { TreeProps, TreeItemProps, MultiTreeProps, SingleTreeProps, DataTreeType } from './Tree.types';

const NOOP = () => { };

export function Tree<T>(props: TreeProps<T>) {
  const { children, selected: propsSelected, expanded, selectableParent = true } = props;
  const multiple = (props as MultiTreeProps<T>).multiple || false;
  const selected: any = multiple ? (propsSelected as T[]).map(String) : String(propsSelected);


  const handlerSelect = React.useCallback((event: React.ChangeEvent<{}>, handlerValue: string[] | string) => {
    const dataTypeNode = (event.target as HTMLElement).closest("[data-tree-type]")! as HTMLElement;
    const type = dataTypeNode?.dataset["treeType"] as DataTreeType;
    const disabled = dataTypeNode?.hasAttribute('disabled');
    if (!disabled && (type === DataTreeType.Parent || type === DataTreeType.Node)) {
      if (selectableParent || DataTreeType.Node === type) {
        const firstPropsSelected: T = multiple ? (propsSelected as T[])[0] : (propsSelected as T);
        const prototype = (firstPropsSelected as any).constructor;

        if (multiple) {
          const multiProps = props as MultiTreeProps<T>;
          const { onSelect = NOOP } = multiProps;
          const multiSelected = (selected as string[]);
          const nodeIds = handlerValue as string[];
          const nextSelected = [
            ...multiSelected.filter(e => !nodeIds.includes(e)),
            ...nodeIds.filter(e => !multiSelected.includes(e)),
          ].map(e => prototype(e) as T);
          if (nextSelected.length) {
            onSelect(event, nextSelected);
          }
        } else {
          const singleProps = props as SingleTreeProps<T>;
          const { onSelect = NOOP } = singleProps;
          const singleSelected = handlerValue as string;
          onSelect(event, prototype(singleSelected) as T);
        }
      }
    }
  }, [propsSelected, selected]);

  const handlerToggle = React.useCallback((event: React.ChangeEvent<{}>, nodeIds: string[]) => {


    // const firstPropsSelected: T = multiple ? (propsSelected as T[])[0] : (propsSelected as T);
    // const prototype = (firstPropsSelected as any).constructor;
    // const expandedT = nodeIds.map(e => prototype(e));
    // // onToggle(event, expandedT as T[]);
  }, []);

  return <StyledTree
    selected={selected}
    multiSelect={multiple as any}
    defaultExpanded={expanded?.map(String)}
    defaultCollapseIcon={<CloseIcon data-tree-type={DataTreeType.ToggleIcon} />}
    defaultExpandIcon={<OpenIcon data-tree-type={DataTreeType.ToggleIcon} />}
    onNodeSelect={handlerSelect}
    onNodeToggle={handlerToggle}
    role="list"
  >
    {children}
  </StyledTree>
}


export function TreeItem<T>(props: TreeItemProps<T>) {
  const { hierarchy } = props;
  const disabled = props.disabled || hierarchy.origin.disabled;
  if (hierarchy.children.length) {
    return <StyledTreeItemParent
      classes={{ content: 'content', label: 'label', selected: 'selected' }}
      role="listitem"
      key={String(hierarchy.id)}
      nodeId={String(hierarchy.id)}
      label={hierarchy.origin.name}
      data-tree-type={DataTreeType.Parent}
      disabled={disabled}
    >
      {hierarchy.children.map(child => <TreeItem key={String(child.id)} hierarchy={child} disabled={child.origin.disabled} />)}
    </StyledTreeItemParent>
  }
  return <StyledTreeItem
    classes={{ content: 'content', label: 'label', selected: 'selected' }}
    role="listitem"
    key={String(hierarchy.id)}
    nodeId={String(hierarchy.id)}
    label={hierarchy.origin.name}
    data-tree-type={DataTreeType.Node}
    disabled={disabled}
  />
}